import React from "react";

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    maxVisible?: number;
}

const Pagination: React.FC<PaginationProps> = ({
    currentPage,
    totalPages,
    onPageChange,
    maxVisible = 5,
}) => {
    if (totalPages <= 1) return null;

    const getPages = (): number[] => {
        let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
        let end = start + maxVisible - 1;

        if (end > totalPages) {
            end = totalPages;
            start = Math.max(1, end - maxVisible + 1);
        }

        return Array.from(
            { length: end - start + 1 },
            (_, i) => start + i
        );
    };

    return (
        <div style={styles.container}>
            {/* Previous */}
            <button
                style={styles.button}
                disabled={currentPage === 1}
                onClick={() => onPageChange(currentPage - 1)}
            >
                ⬅ Prev
            </button>

            {/* Page Numbers */}
            {getPages().map((page) => (
                <button
                    key={page}
                    onClick={() => onPageChange(page)}
                    style={{
                        ...styles.button,
                        ...(page === currentPage ? styles.active : {}),
                    }}
                >
                    {page}
                </button>
            ))}

            {/* Next */}
            <button
                style={styles.button}
                disabled={currentPage === totalPages}
                onClick={() => onPageChange(currentPage + 1)}
            >
                Next ➡
            </button>
        </div>
    );
};

export default Pagination;

const styles: {
    container: React.CSSProperties;
    button: React.CSSProperties;
    active: React.CSSProperties;
} = {
    container: {
        display: "flex",
        gap: "8px",
        justifyContent: "center",
        marginTop: "0px",
        position: 'sticky',
        bottom: 0,
        backgroundColor: '#FFF',
        maxWidth: 'max-content',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    button: {
        padding: "6px 12px",
        border: "1px solid #ccc",
        background: "#fff",
        cursor: "pointer",
    },
    active: {
        background: "#8953d7",
        color: "#fff",
        borderColor: "#8953d7",
    },
};
